import { render, staticRenderFns } from "./TestPackageApplyTestPackage.vue?vue&type=template&id=dd017ca4"
import script from "./TestPackageApplyTestPackage.vue?vue&type=script&lang=js"
export * from "./TestPackageApplyTestPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports